import { render, staticRenderFns } from "./PdpTilesForSize.vue?vue&type=template&id=dc007a9c&scoped=true&"
import script from "./PdpTilesForSize.vue?vue&type=script&lang=js&"
export * from "./PdpTilesForSize.vue?vue&type=script&lang=js&"
import style0 from "./PdpTilesForSize.vue?vue&type=style&index=0&id=dc007a9c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc007a9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpTileForSize: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpTileForSize.vue').default})
